import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { withMotionMax } from '@hoc/withMotionMax';
import CarouselProvider from '@stories/Components/Misc/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Pagination from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination';
import Icon from '@stories/Components/Misc/Icon/Icon';
import VideoModal from '@stories/Components/Misc/VideoModal/VideoModal';
import { MotionConfig } from 'framer-motion';
import React, { useMemo, useState } from 'react';
import { MediaGalleryStyles as S } from './MediaGallery.styles';
// Need to split the mediaItems up into 4 slide layouts (desktop layout)
function chunkArray(inputArray) {
    const layout = [9, 12, 7, 6];
    const layoutArray = [];
    let i = 0;
    let layoutIndex = 0;
    while (i < inputArray.length) {
        const size = layout[layoutIndex];
        const chunk = inputArray.slice(i, i + size);
        layoutArray.push(chunk);
        i += size;
        layoutIndex = (layoutIndex + 1) % layout.length;
    }
    return layoutArray;
}
// Need to split the mediaItems into a smaller array for the first slide (mobile layout)
function chunkArrayMobile(inputArray) {
    const layout = [3, 6];
    const layoutArray = [];
    let i = 0;
    let layoutIndex = 0;
    while (i < inputArray.length) {
        if (i < 3) {
            layoutIndex = 0;
        }
        else {
            layoutIndex = 1;
        }
        const size = layout[layoutIndex];
        const chunk = inputArray.slice(i, i + size);
        layoutArray.push(chunk);
        i += size;
    }
    return layoutArray;
}
const MediaGallery = (props) => {
    const [chunkedMedia, setChunkedMedia] = useState([]);
    const [mobileChunkedMedia, setMobileChunkedMedia] = useState([]);
    const [showModal, setShowModal] = React.useState(false);
    const [mediaSrc, setMediaSrc] = React.useState('');
    useMemo(() => {
        const chunks = chunkArray(props.mediaItems);
        setChunkedMedia(chunks);
        const mobileChunks = chunkArrayMobile(props.mediaItems);
        setMobileChunkedMedia(mobileChunks);
    }, [props.mediaItems]);
    return (React.createElement(S.Container, { wave: "wave-3", hideWave: props.hideWave, tabName: props.tabName, "data-theme": props.theme || 'blue' },
        props.title && React.createElement(S.Title, null, props.title),
        props.mediaItems && (React.createElement(React.Fragment, null,
            React.createElement(S.DesktopLayout, null,
                React.createElement(CarouselProvider, { count: chunkedMedia.length, paddingOffset: 0, previousText: props.translations?.['custom.afme.previous'], nextText: props.translations?.['custom.afme.next'] },
                    React.createElement(MotionConfig, { transition: { duration: 0.5, ease: 'easeInOut' } },
                        React.createElement(S.CarouselLayout, null,
                            React.createElement(S.CarouselWrapper, null,
                                React.createElement(S.Track, { trackMutations: true }, props.mediaItems &&
                                    chunkedMedia &&
                                    chunkedMedia.map((chunk, index) => (React.createElement(S.Item, { key: `carousel-slide-${index}` }, chunk.map((media, mediaIndex) => (React.createElement(S.MediaItem, { key: `slide-item-${index}__media-item-${mediaIndex}` }, renderMediaType(media))))))))),
                            React.createElement(S.Pagination, null,
                                React.createElement(Pagination, null)))))),
            React.createElement(S.MobileLayout, null,
                React.createElement(CarouselProvider, { count: mobileChunkedMedia.length, paddingOffset: 0, previousText: props.translations?.['custom.afme.previous'], nextText: props.translations?.['custom.afme.next'] },
                    React.createElement(MotionConfig, { transition: { duration: 0.5, ease: 'easeInOut' } },
                        React.createElement(S.CarouselLayout, null,
                            React.createElement(S.CarouselWrapper, null,
                                React.createElement(S.Track, { trackMutations: true }, props.mediaItems &&
                                    mobileChunkedMedia &&
                                    mobileChunkedMedia.map((chunk, index) => (React.createElement(S.Item, { key: `carousel-slide-${index}` }, chunk.map((media, mediaIndex) => (React.createElement(S.MediaItem, { key: `slide-item-${index}__media-item-${mediaIndex}` }, renderMediaType(media))))))))),
                            React.createElement(S.Pagination, null,
                                React.createElement(Pagination, null)))))))),
        React.createElement(VideoModal, { isVisible: showModal, closeBtnTxt: (props.translations && props.translations['custom.afme.close-btn']) ?? 'Close', src: mediaSrc, onClick: () => {
                setShowModal(!showModal);
            } })));
    function renderMediaType(media) {
        switch (media.mediaType) {
            case 'image':
                return (React.createElement(S.Image, { ...getSrcs(media, 710, 360, 10, 710 / 504), sizes: `${until(Device.Tablet)} 50vw, 710px`, alt: media.altText ?? '', width: media.width, height: media.height, loading: "lazy", draggable: false }));
            case 'audio':
                return (React.createElement(React.Fragment, null,
                    React.createElement("audio", { src: media.src, controls: true })));
            case 'video':
                return (React.createElement(React.Fragment, null,
                    media.poster?.src ? (React.createElement(S.Image, { ...getSrcs(media, 710, 360, 10, 710 / 504), sizes: `${until(Device.Tablet)} 50vw, 710px`, alt: media.poster?.altText ?? '', width: media.width, height: media.height, loading: "lazy", draggable: false })) : (React.createElement(S.Video, { src: media.src, playsInline: true, preload: "metadata", width: "665", height: "506" })),
                    React.createElement(S.PlayButton, { type: "button", onClick: () => {
                            setShowModal(true);
                            setMediaSrc(media.src);
                        }, "aria-label": props.translations?.['custom.afme.play'] },
                        React.createElement(Icon, { icon: "play" }))));
        }
    }
};
export default withMotionMax(MediaGallery);
